import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import type { SearchFilters } from '@shared/api-types.js';

export function useSearchListings(filters: SearchFilters, enabled = true) {
  return useQuery({
    queryKey: ['search', 'listings', filters],
    queryFn: () => api.search.listings(filters),
    enabled,
    staleTime: 30_000,
    // Keep the previous result on screen while a new query (different filters,
    // e.g. user panned the map) is in flight. Avoids the "list goes blank →
    // markers disappear → new ones pop in" flash.
    placeholderData: keepPreviousData,
  });
}

export function useAuthProviders() {
  return useQuery({
    queryKey: ['auth', 'providers'],
    queryFn: () => api.auth.providers(),
    staleTime: 5 * 60_000,
  });
}
